import React from "react";
import autobind from "autobind-decorator";
import { connect } from "react-redux";

// import config from "config";
import services from "core/services";
import { Component, Loading, Page } from "core/components";
import { withLocale } from "core/decorators";
import {
  SliderComponent,
  Title,
  CategoryList,
  CategorySwiper,
  ProductSwiper,
} from "content/components";

import translations from "./i18n";
import classes from "./styles.module.css";

class HomePage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      env: {},
      sliderItems: [],
      loadingSlider: false,

      newProductItems: [],
      moreDiscountItems: [],
      mostPopularItems: [],
      bestSellersItems: [],
      loadingNewest: false,
      loadingMoreDiscount: false,
      loadingMostPopular: false,
      loadingBestSellers: false,

      promotion1Items: [],
      promotion2Items: [],
      promotion3Items: [],
      loadingPromotions1: false,
      loadingPromotions2: false,
      loadingPromotions3: false,
    };

    this.props.translator.addModuleResource("home", translations);
    this.interval = null;
  }

  /**
   * @inheritdoc
   */
  componentDidMount() {
    // console.log('devicePixelRatio:', devicePixelRatio)
    const env = this.initialValue;
    this.setState({ env: env });

    this.reload();

    if (env.reloadPagePeriod > 0) {
      this.interval = setInterval(() => {
        this.reload();
      }, env.reloadPagePeriod);
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  ////////////////////////////////////////////////////////////////////////////////////////////
  // API Functions ///////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////
  get initialValue() {
    const { env } = this.props;
    const page = env && env.pages && env.pages.home;

    return {
      page: page,
      layout: page && page.layout,
      reloadPagePeriod: (env && env.reloadPagePeriod) || 60 * 1000,
    };
  }

  reload() {
    this.getSlider();

    this.getProducts("newProductItems", "loadingNewest", "newest");
    this.getProducts(
      "moreDiscountItems",
      "loadingMoreDiscount",
      "more_discount"
    );
    this.getProducts("mostPopularItems", "loadingMostPopular", "most_popular");
    this.getProducts("bestSellersItems", "loadingBestSellers", "best_sellers");

    this.getPromotions("promotion1Items", "loadingPromotions1", 1);
    this.getPromotions("promotion2Items", "loadingPromotions2", 2);
    this.getPromotions("promotion3Items", "loadingPromotions3", 3);
  }

  getSlider() {
    if (this.state.loadingSlider) return;

    this.setState({ loadingSlider: true });

    const params = {
      products: true,
      store: 2,
    };

    services.ecommerce.Basic.getSliders(params)
      .then((r) => {
        this.setState({
          sliderItems: r.data.nodes,
        });
      })
      .catch((e) => { })
      .finally((r) => {
        this.setState({ loadingSlider: false });
      });
  }

  getProducts(stateKeyItems, stateKeyLoading, order_by) {
    if (this.state[stateKeyLoading]) return;

    this.setState({ [stateKeyLoading]: true });

    const params = {
      store: 2,
      limit: 5,
      offset: 0,
      order_by: order_by,
      check_availability: true,
    };

    services.ecommerce.Basic.getProducts(params)
      .then((r) => {
        this.setState({
          [stateKeyItems]: r.data.nodes,
        });
      })
      .catch((e) => { })
      .finally((r) => {
        this.setState({ [stateKeyLoading]: false });
      });
  }

  getPromotions(stateKeyItems, stateKeyLoading, number) {
    if (this.state[stateKeyLoading]) return;

    this.setState({ [stateKeyLoading]: true });

    const params = {
      store: 2,
    };

    services.ecommerce.Basic.getPromotion(number, params)
      .then((r) => {
        this.setState({
          [stateKeyItems]: r.data.nodes,
        });
      })
      .catch((e) => { })
      .finally((r) => {
        this.setState({ [stateKeyLoading]: false });
      });
  }

  ////////////////////////////////////////////////////////////////////////////////////////////
  // Render Functions ////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////
  /**
   * render swiper in page
   */
  renderSlider() {
    const { navigate } = this.props;
    const { sliderItems, loadingSlider, env } = this.state;

    const slider = (env.layout && env.layout.slider) || { autoplay: { delay: 5000 }, loop: true, ratio: "var(--slider-item-ratio)" }

    if (loadingSlider && sliderItems.length == 0) {
      return <Loading height={185} />;
    }

    if (sliderItems.length) {
      return (
        <SliderComponent
          items={sliderItems}
          navigate={navigate}
          {...slider}
        />
      );
    }

    return;
  }

  renderPromotion(promotionItems, promotionLoading) {
    const { navigate } = this.props;

    if (promotionLoading && promotionItems.length == 0) {
      return <Loading height={125} />;
    }

    if (promotionItems.length) {
      return (
        <SliderComponent
          items={promotionItems}
          ratio={"var(--promotion-swiper-item-ratio)"}
          navigate={navigate}
          pagination={true}
        />
      );
    }

    return;
  }

  renderEmpty() {
    return <div className={classes.empty}>آیتمی جهت نمایش وجود ندارد</div>;
  }

  renderCategoryListView() {
    const { category, navigate } = this.props;
    const initialProps = this.initialValue;
    const categoryListView =
      (initialProps.layout && initialProps.layout.categoryListView) ||
      "default";

    switch (categoryListView) {
      case "complete":
        return <CategoryList items={category} navigation={navigate} />;
      default:
        return <CategorySwiper items={category} navigation={true} />;
    }
  }

  render() {
    const { navigate } = this.props;
    const navigation = true;
    // console.log(navigate)
    // console.log('services.env.app.layout.homeCategoryType:', services.env.get('app:layout.homeCategoryType'))

    return (
      <Page
        pageName="home"
        showCart={true}
        showSearch={true}
        showBack={false}
        navigate={navigate}
      >
        <div className={`page-bottom-padding`}>
          {/* TODO add delivery address */}

          {/* TODO add current order */}

          <div className={classes.slider}>{this.renderSlider()}</div>

          <div className={`${classes.parentNode} ${classes.categoryBox}`}>
            <Title icon="mdi-format-list-bulleted" title="دسته‌بندی کالاها" />
            {this.renderCategoryListView()}
          </div>

          <div className={`${classes.parentNode} ${classes.newProductBox}`}>
            <Title
              icon="mdi-new-box"
              title="کالاهای جدید"
              hasMore={true}
              link="/node/main_categories/newest"
            // onClick={() => navigate.navigate("/node/main_categories", { props: { navigate: navigate, sort: "newest" } })}
            />

            <ProductSwiper
              loading={
                this.state.loadingNewest &&
                this.state.newProductItems.length == 0
              }
              items={this.state.newProductItems}
              icon="mdi-new-box"
              navigate={navigate}
              navigation={navigation}
            />
          </div>

          {this.renderPromotion(
            this.state.promotion1Items,
            this.state.loadingPromotions1
          )}

          <div
            className={`${classes.parentNode} ${classes.discountProductBox}`}
          >
            <Title
              icon="mdi-sale"
              title="بیشترین تخفیف‌ها"
              hasMore={true}
              link="/node/main_categories/more_discount"
            // onClick={() => navigate.navigate("/node/main_categories", { props: { navigate: navigate, sort: "more_discount" } })}
            />

            <ProductSwiper
              loading={
                this.state.loadingMoreDiscount &&
                this.state.moreDiscountItems.length == 0
              }
              items={this.state.moreDiscountItems}
              icon="mdi-sale"
              navigate={navigate}
              navigation={navigation}
            />
          </div>

          {this.renderPromotion(
            this.state.promotion2Items,
            this.state.loadingPromotions2
          )}

          <div className={`${classes.parentNode} ${classes.popularProductBox}`}>
            <Title
              icon="mdi-thumb-up"
              title="محبوب‌ترین‌ها"
              hasMore={true}
              link="/node/main_categories/most_popular"
            // onClick={() => navigate.navigate("/node/main_categories", { props: { navigate: navigate, sort: "most_popular" } })}
            />

            <ProductSwiper
              loading={
                this.state.loadingMostPopular &&
                this.state.mostPopularItems.length == 0
              }
              items={this.state.mostPopularItems}
              icon="mdi-thumb-up"
              navigate={navigate}
              navigation={navigation}
            />
          </div>

          {this.renderPromotion(
            this.state.promotion3Items,
            this.state.loadingPromotions3
          )}

          <div className={`${classes.parentNode} ${classes.saleProductBox}`}>
            <Title
              icon="mdi-coins"
              title="پرفروش‌ترین"
              hasMore={true}
              link="/node/main_categories/best_sellers"
            // onClick={() => navigate.navigate("/node/main_categories", { props: { navigate: navigate, sort: "best_sellers" } })}
            />

            <ProductSwiper
              loading={
                this.state.loadingBestSellers &&
                this.state.bestSellersItems.length == 0
              }
              items={this.state.bestSellersItems}
              icon="mdi-coins"
              navigate={navigate}
              navigation={navigation}
            />
          </div>
        </div>
      </Page>
    );
  }
}

export default connect((state) => ({
  category: state.Category.category,
  env: state.General.env,
}))(withLocale("home")(autobind(HomePage)));
